import { render, staticRenderFns } from "./railway-control-content.vue?vue&type=template&id=b898d670"
import script from "./railway-control-content.vue?vue&type=script&lang=js"
export * from "./railway-control-content.vue?vue&type=script&lang=js"
import style0 from "./railway-control-content.vue?vue&type=style&index=0&id=b898d670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports